export const messages = {
  en: {
    couponShopPool: {
      title: 'Coupon Pool',
      addTitle: 'Add Merchant Coupon Pool',
      editTitle: 'Edit Merchant Coupon Pool',
      deleteTitle: 'Confirm Operation',
      deleteContent: 'Confirm to delete merchant coupon pool?',
      couponId: 'Coupon ID',
      couponName: 'Coupon Name',
      faceValue: 'Face Value',
      stock: 'Stock',
      validity: 'Validity',
      shopId: 'Shop ID',
      operation: 'Operation',
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
      parkingCoupon: 'Parking Coupon',
      manualGift: 'Manual Gift',
      buyCoupon: 'Buy Coupon',
      couponPoolCode: 'Coupon Pool Code',
      couponType: 'Coupon Type',
      purchasePrice: 'Purchase Price',
      quantity: 'Quantity',
      status: 'Status',
      onShelf: 'On Shelf',
      offShelf: 'Off Shelf',
      choose: 'Choose',
      searchPlaceholder: 'Enter coupon pool name'
    }
  },
  zh: {
    couponShopPool: {
      title: '优惠券池',
      addTitle: '添加商家优惠券池',
      editTitle: '修改商家优惠券池',
      deleteTitle: '请确认您的操作!',
      deleteContent: '确定删除商家优惠券池',
      couponId: '优惠券编号',
      couponName: '优惠券名称',
      faceValue: '面值',
      stock: '库存',
      validity: '有效期',
      shopId: '店铺ID',
      operation: '操作',
      confirm: '确认',
      cancel: '取消',
      save: '保存',
      parkingCoupon: '停车劵赠送',
      manualGift: '手工赠送',
      buyCoupon: '购买优惠劵',
      couponPoolCode: '优惠券池编码',
      couponType: '优惠券类型',
      purchasePrice: '购买价格',
      quantity: '数量',
      status: '状态',
      onShelf: '上架',
      offShelf: '停售',
      choose: '选择',
      searchPlaceholder: '输入优惠券池名称'
    }
  }
}